import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2Reviewer } from '@/api/model/interfaces';

export default class PackageKS2ReviewerOdata extends OdataManager<PackageKS2Reviewer> {}
